

import { addSubscribeNewsletterToForm } from '../../../layouts/general/subscribe-newsletter';

let formNewsletterLabel = document.getElementById('js-form-subscribe-info');
addSubscribeNewsletterToForm('js-newsletter-subscribe', formNewsletterLabel);




// WEBPACK FOOTER //
// ./src/components/templates/our-newsletter/our-newsletter.js